import React from "react";
import { Box, Typography } from "@mui/material";

const Impressum = () => (
  <Box sx={{ padding: 4, textAlign: "center" }}>
    <Typography variant="h4" gutterBottom color ="primary">
      Impressum
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Diese Plattform wird betrieben von:<br /><br />

      <strong>Scivola</strong><br />
      Stumpergasse 2/13<br />
      1060 Wien<br /><br />

      Vertretungsberechtigte: Maximilian Kröpfl, Paul von Hirschhausen, Maximilian Zimmer<br />
      Telefon: +49 177 4891822<br />
      E-Mail: mk@maxdoes.law<br /><br />

      {/* Umsatzsteuer-Identifikationsnummer gem. §27a UStG: [Deine USt-ID oder Hinweis Kleinunternehmerregelung]<br /> */}
      {/* Handelsregister/Firmenbuchnummer: [Eintrag oder Hinweis „nicht eingetragen“]<br /> */}
      {/* Registergericht: [Gericht ergänzen, falls eingetragen]<br /><br /> */}

      {/* Berufsbezeichnung: [falls zutreffend]<br /> */}
      {/* Zuständige Kammer/Aufsichtsbehörde: [falls zutreffend]<br /> */}
      {/* Berufsrechtliche Vorschriften: [ggf. mit Link ergänzen]<br /><br /> */}

      Plattform der EU-Kommission zur Online-Streitbeilegung:<br />
      <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
        https://ec.europa.eu/consumers/odr
      </a><br /><br />

      Hinweis gemäß Verbraucherstreitbeilegungsgesetz:<br />
      Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
    </Typography>
  </Box>
);

export default Impressum;
